import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import * as React from 'react';
import TextColumn from './TextColumn.mjs';

const Confirmation = ({ header, text })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const defaultHeader = $__i18n._({
        id: "success.title"
    });
    const defaultText = $__i18n._({
        id: "login.success.content"
    });
    return /*#__PURE__*/ React.createElement(TextColumn, {
        header: header ?? defaultHeader,
        body: text ?? defaultText,
        align: "center"
    });
};

export { Confirmation };
//# sourceMappingURL=Confirmation.mjs.map
